var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKotlinLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 73.714,
    y1: 910.226,
    x2: 105.452,
    y2: 878.134,
    gradientTransform: "translate(-64.139 -782.556) scale(0.893)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0296d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8371d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 69.813,
    y1: 905.226,
    x2: 102.279,
    y2: 875.745,
    gradientTransform: "translate(-64.139 -782.556) scale(0.893)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cb55c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f28e0e"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_kotlin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2,2V30H30v-.047l-6.95-7L16.1,15.946l6.95-7.012L29.938,2Z",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.318,2,2,16.318V30h.124L16.132,15.992l-.031-.031L23.05,8.95,29.938,2Z",
    style: {
      fill: "url(#b)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKotlinLight);
export default __webpack_public_path__ + "static/media/kotlin_light.ce7dfda3c3cced0bf22d289561b55d8e.svg";
export { ForwardRef as ReactComponent };